import api from 'app/shared/utils/api';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import CoreProductInvoice from 'app/shared/model/CoreProductInvoice';
import Graphs from 'app/shared/model/Graphs';
import PropertiesReport from 'app/shared/model/PropertiesReport';
import BoostAdReport from 'app/shared/model/BoostAdReport';
import BoostAdPreviews from 'app/shared/model/BoostAdPreviews';
import Listings from 'app/shared/model/Listings';
import OverviewFilter from 'app/shared/model/OverviewFilter';

import competitorData from 'app/shared/model/competitorData';

import LoadingConstants from 'app/shared/constants/LoadingConstants';

import analyticsUtils from 'app/shared/utils/analyticsUtils';

const AnalyticsActions = {
    comscore() {
        return dispatch => dispatch(api.users.analytics.comscore())
            .catch(err => console.error('could not ping comscore', err));
    },
    getCoreProductInvoice(params = {}) {
        return dispatch => dispatch(api.users.analytics.getCoreProductInvoice(params))
            .then((result) => {
                if (result.success) {
                    const coreProductInvoice = CoreProductInvoice(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTIC_AD_PRODUCTS_GET_SUCCESS,
                        payload: coreProductInvoice,
                    });
                }
                return dispatch({
                    type: DispatchConstants.ANALYTIC_AD_PRODUCTS_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.ANALYTIC_AD_PRODUCTS_GET_FAIL,
                payload: err,
            }));
    },
    getPropertiesReport(params = {}) {
        return dispatch => dispatch(api.users.analytics.getProperties(params))
            .then((result) => {
                if (result.success) {
                    const propertiesReport = PropertiesReport(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTICS_PROPERTIES_GET_SUCCESS,
                        payload: propertiesReport,
                    });
                }
                return dispatch({
                    type: DispatchConstants.ANALYTICS_PROPERTIES_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.ANALYTICS_PROPERTIES_GET_FAIL,
                payload: err,
            }));
    },
    getBoostAdReport(params = {}) {
        return dispatch => dispatch(api.users.analytics.getBoostAdReport(params))
            .then((result) => {
                if (result.success) {
                    const boostAdReport = BoostAdReport(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTICS_BOOST_AD_GET_SUCCESS,
                        payload: boostAdReport,
                    });
                }
                return dispatch({
                    type: DispatchConstants.ANALYTICS_BOOST_AD_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.ANALYTICS_BOOST_AD_GET_FAIL,
                payload: err,
            }));
    },
    getBoostAdPreviews(params = {}) {
        return (dispatch) => {
            dispatch({ type: DispatchConstants.ANALYTICS_BOOST_AD_PREVIEWS_GET_LOADING });
            return dispatch(api.users.analytics.getBoostAdPreviews(params))
                .then((result) => {
                    if (result.success) {
                        const boostAdPreviews = BoostAdPreviews(result.response);

                        return dispatch({
                            type: DispatchConstants.ANALYTICS_BOOST_AD_PREVIEWS_GET_SUCCESS,
                            payload: boostAdPreviews,
                        });
                    }
                    return dispatch({
                        type: DispatchConstants.ANALYTICS_BOOST_AD_PREVIEWS_GET_FAIL,
                        payload: result,
                    });
                })
                .catch(err => dispatch({
                    type: DispatchConstants.ANALYTICS_BOOST_AD_PREVIEWS_GET_FAIL,
                    payload: err,
                }));
        };
    },
    getMonthlyOverviewStats(filterParams = {}) {
        const ranges = analyticsUtils.getOneYearMonthRanges();
        const failType = DispatchConstants.ANALYTICS_OVERVIEW_INVOICES_GET_FAIL;
        return dispatch => Promise.all(ranges.map((range) => {
            const params = {
                year: range[0],
                month: range[1],
                ...filterParams,
            };
            return dispatch(api.users.analytics.overview.getMonthlyOverviewSummary(params))
                .then(response => response.response);
        })).then((stats) => {
            const graphs = {
                coreProduct: {
                    total: {
                        total: stats.reduce((total, stat) => total + stat.coreProductCost, 0),
                        months: stats.map(stat => ({
                            startDate: analyticsUtils.createDateFromYearMonth(stat.year, stat.month),
                            total: stat.coreProductCost,
                        })),
                    },
                },
                rocketship: {
                    total: {
                        total: stats.reduce((total, stat) => total + stat.rocketshipCost, 0),
                        months: stats.map(stat => ({
                            startDate: analyticsUtils.createDateFromYearMonth(stat.year, stat.month),
                            total: stat.rocketshipCost,
                        })),
                    },
                },
                boost: {
                    total: {
                        total: stats.reduce((total, stat) => total + stat.boostCost, 0),
                        months: stats.map(stat => ({
                            startDate: analyticsUtils.createDateFromYearMonth(stat.year, stat.month),
                            total: stat.boostCost,
                        })),
                    },
                },
            };
            return Graphs(graphs);
        }).then(graphModel => dispatch({
            type: DispatchConstants.ANALYTICS_OVERVIEW_GET_SUCCESS,
            payload: graphModel,
        })).catch(err => dispatch({
            type: failType,
            payload: err,
        }));
    },
    getGraphs(graphsType = '', params = {}) {
        let endpoint;
        let failType;
        switch (graphsType) {
            case 'listings':
                endpoint = api.users.analytics.overview.getListings;
                failType = DispatchConstants.ANALYTICS_OVERVIEW_LISTINGS_GET_FAIL;
                break;
            case 'reviews':
                endpoint = api.users.analytics.overview.getReviews;
                failType = DispatchConstants.ANALYTICS_OVERVIEW_REVIEWS_GET_FAIL;
                break;
            default:
                endpoint = api.users.analytics.overview.getListings;
                failType = DispatchConstants.ANALYTICS_OVERVIEW_LISTINGS_GET_FAIL;
                break;
        }
        return dispatch => dispatch(endpoint(params))
            .then((result) => {
                if (result.success) {
                    const graphs = Graphs(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTICS_OVERVIEW_GET_SUCCESS,
                        payload: graphs,
                    });
                }
                return dispatch({
                    type: failType,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: failType,
                payload: err,
            }));
    },
    getMultifamilyListings() {
        return dispatch => dispatch(api.users.properties.getMultifamilyListings())
            .then((result) => {
                if (result.success) {
                    const listings = Listings(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTICS_OVERVIEW_ALL_LISTINGS_GET_SUCCESS,
                        payload: listings,
                    });
                }
                return dispatch({
                    type: DispatchConstants.ANALYTICS_OVERVIEW_ALL_LISTINGS_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.ANALYTICS_OVERVIEW_ALL_LISTINGS_GET_FAIL,
                payload: err,
            }));
    },
    getOverviewFilter() {
        return dispatch => dispatch(api.users.analytics.overview.getFilter())
            .then((result) => {
                if (result.success) {
                    const listings = OverviewFilter(result.response);

                    return dispatch({
                        type: DispatchConstants.ANALYTICS_OVERVIEW_FILTER_GET_SUCCESS,
                        payload: listings,
                    });
                }
                return dispatch({
                    type: DispatchConstants.ANALYTICS_OVERVIEW_FILTER_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.ANALYTICS_OVERVIEW_FILTER_GET_FAIL,
                payload: err,
            }));
    },
    getPropertyCompetitionData(params = {}) {
        return (dispatch) => {
            dispatch({
                type: DispatchConstants.ANALYTICS_COMPETITION_SET_LOADING_STATE,
                payload: LoadingConstants.LOADING,
            });
            dispatch(api.users.analytics.competition.getPropertyCompetition(params))
                .then((result) => {
                    if (result.success) {
                        const formattedData = competitorData(result.response);
                        if (result.response.properties.length === 0) {
                            throw new Error();
                        }
                        dispatch({
                            type: DispatchConstants.ANALYTICS_PROPERTY_RENT_COMPARISON_GET_SUCCESS,
                            payload: formattedData,
                        });
                    }
                })
                .catch(() => {
                    dispatch({
                        type: DispatchConstants.ANALYTICS_COMPETITION_SET_LOADING_STATE,
                        payload: LoadingConstants.ERROR,
                    });
                });
        };
    },
    clearPropertyCompetitionData() {
        return dispatch => dispatch({
            type: DispatchConstants.ANALYTICS_COMPETITION_CLEAR,
        });
    },
};

export default AnalyticsActions;
